
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/booking/patient",
      function () {
        return require("private-next-pages/booking/patient.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/booking/patient"])
      });
    }
  